/* Surferelle trip gallery: opens drawer photos in a full-screen popup */
(() => {
  const init = (root) => {
    if (root.dataset.sftGalleryReady) return;
    const items = [...root.querySelectorAll('[data-sft-gallery-item]')];
    const lb = root.querySelector('[data-sft-lightbox]');
    if (!items.length || !lb || typeof lb.showModal !== 'function') return;
    root.dataset.sftGalleryReady = '1';

    const img = lb.querySelector('.sft-lb__img');
    const stage = lb.querySelector('[data-sft-lb-stage]');
    const current = lb.querySelector('[data-sft-lb-current]');
    const caption = lb.querySelector('[data-sft-lb-caption]');
    const multi = items.length > 1;
    let index = 0;
    let opener = null;
    let token = 0;

    const preload = (i) => {
      const it = items[(i + items.length) % items.length];
      if (it && !it._sftPre) { it._sftPre = new Image(); it._sftPre.src = it.dataset.full; }
    };

    const show = (n, dir) => {
      index = (n + items.length) % items.length;
      const it = items[index];
      const my = ++token;
      lb.dataset.dir = dir || '';
      img.classList.remove('is-in');
      lb.classList.add('is-loading');
      current.textContent = index + 1;
      caption.textContent = it.dataset.alt || '';

      const pre = new Image();
      pre.onload = pre.onerror = () => {
        if (my !== token) return;
        // short wait so the slide-out finishes before the new photo comes in
        setTimeout(() => {
          if (my !== token) return;
          img.src = it.dataset.full;
          img.alt = it.dataset.alt || '';
          lb.classList.remove('is-loading');
          requestAnimationFrame(() => requestAnimationFrame(() => img.classList.add('is-in')));
        }, dir ? 120 : 0);
      };
      pre.src = it.dataset.full;
      if (multi) { preload(index + 1); preload(index - 1); }
    };

    const open = (n, btn) => {
      opener = btn;
      lb.classList.remove('is-closing');
      lb.showModal();
      show(n);
    };

    const close = () => {
      if (!lb.open || lb.classList.contains('is-closing')) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      lb.classList.add('is-closing');
      setTimeout(() => {
        lb.close();
        lb.classList.remove('is-closing');
        img.classList.remove('is-in');
        if (opener) opener.focus({ preventScroll: true });
      }, reduce ? 0 : 200);
    };

    items.forEach((btn, i) => btn.addEventListener('click', () => open(i, btn)));

    // Esc closes only the popup, never the drawer behind it
    lb.addEventListener('cancel', (e) => { e.preventDefault(); close(); });

    lb.addEventListener('keydown', (e) => {
      e.stopPropagation();
      if (e.key === 'ArrowRight' && multi) show(index + 1, 'next');
      else if (e.key === 'ArrowLeft' && multi) show(index - 1, 'prev');
    });

    lb.addEventListener('click', (e) => {
      // keep clicks inside the popup from reaching the drawer's own handlers
      e.stopPropagation();
      if (e.target.closest('[data-sft-lb-close]')) return close();
      if (e.target.closest('[data-sft-lb-next]')) return show(index + 1, 'next');
      if (e.target.closest('[data-sft-lb-prev]')) return show(index - 1, 'prev');
      // click on the empty area around the photo closes the popup
      if (e.target === lb || e.target === stage) close();
    });

    // Swipe left/right on touch screens
    let startX = null;
    let startY = null;
    stage.addEventListener('pointerdown', (e) => { startX = e.clientX; startY = e.clientY; });
    stage.addEventListener('pointerup', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      startX = startY = null;
      if (multi && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        show(index + (dx < 0 ? 1 : -1), dx < 0 ? 'next' : 'prev');
      }
    });
    stage.addEventListener('pointercancel', () => { startX = startY = null; });
  };

  const run = (scope) => scope.querySelectorAll('[data-sft-gallery]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document));
  } else {
    run(document);
  }
  // Theme editor: re-bind when the section is re-rendered
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();